import React, { useCallback, useMemo } from 'react'
import { useTranslation } from '../../../../hooks/locale'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from '../../../../redux/types'
import {
    getCurrentOpenedFilterModal,
    getFiltersConfiguration,
    revertFiltersConfiguration,
    setCurrentOpenedFilterModal,
} from '../../../../redux/filters'
import { FilterModalType } from '../../filter-sort-section/types'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import FilterModal from '../filter-modal'
import { Container, FilterIcon } from './styles'
import { Chip } from 'react-components'

interface Props {
    filterStaticData: FilterSectionTransport
    showOnlyIcon?: boolean
}

const FilterPill: React.FC<Props> = ({ filterStaticData, showOnlyIcon = false }) => {
    const dispatch = useDispatch<Dispatch>()
    const { t } = useTranslation()
    const currentOpenedFilterModal = useSelector(getCurrentOpenedFilterModal)
    const filtersConfiguration = useSelector(getFiltersConfiguration)

    const hasActiveFilters = useMemo(() => {
        return filtersConfiguration?.filters?.some(filter => filter.items?.some(item => item.checked))
    }, [filtersConfiguration])

    const handleModalToggle = useCallback(() => {
        if (currentOpenedFilterModal === FilterModalType.FILTERS) {
            dispatch(revertFiltersConfiguration())
            dispatch(setCurrentOpenedFilterModal(FilterModalType.NONE))
        } else {
            dispatch(setCurrentOpenedFilterModal(FilterModalType.FILTERS))
        }
    }, [currentOpenedFilterModal, dispatch])

    const handleMainFilterClick = useCallback(() => {
        handleModalToggle()
    }, [handleModalToggle])

    const label = showOnlyIcon ? '' : t('mobileFilter.filters')

    return (
        <Container>
            <Chip onClick={handleMainFilterClick} label={label} icon={<FilterIcon />} selected={hasActiveFilters} />
            <FilterModal handleModalToggle={handleModalToggle} filterStaticData={filterStaticData} />
        </Container>
    )
}

export default FilterPill
